import { initSeats } from 'store/pages/event/actions/initSeats'
import { showEventFees } from 'store/pages/event/actions/showEventFees'
import { EventSlice } from 'store/pages/event/slice'

import { fetchMetadata } from './fetchMetadata'
import { getBulkData } from './getBulkData'
import { getData } from './getData'
import { getGoods } from './getGoods'

export const EventActions = {
  ...EventSlice.actions,
  showEventFees,
  fetchMetadata,
  getGoods,
  initSeats,
  getData,
  getBulkData,
}
